import React from "react"
import echarts from "echarts"
import { Icon, Popover } from "antd"
import "antd/lib/popover/style"
import Util from "../../../util/util"
import Pie from "../../../components/charts/pie"
import Sex from "../../../components/charts/sex"
import DataShop from "../../../data/shop"
import "./VisitorCount.less"
import Loading from "../../../components/Loading"
import moment from "moment"

function arriveFormat(data) {
  var arrNums = {
    one: "1次",
    two: "2次",
    three: "3次",
    four: "4次",
    more: "5次及以上",
  }
  var format = []
  for (let key in data) {
    var value = data[key]
    if (value) {
      var el = {
        value: value,
        name: arrNums[key],
      }
      format.push(el)
    }
  }
  if (format.length) return format
  else return false
}

// 到访分析
class VisitorCount extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      gender: null,
      vnum: null,
      loading: true,
    }
  }

  componentDidMount() {
    this.getData()
  }

  getData() {
    let { id, date } = this.props
    this.setState({ loading: true })
    DataShop.getVisitorRecord(id, date).then((res) => {
      let data = res.data || {}
      let gender = data.gender || null

      let vnum = null
      if (data.vnum) {
        vnum = arriveFormat(data.vnum)
      }
      let customerType = null
      if (data.customerType) {
        customerType = [
          { value: data.customerType.one, name: "新顾客" },
          { value: data.customerType.more, name: "老顾客" },
        ]
      }
      let trend = null
      if (data.trend) {
        trend = data.trend
        setTimeout(() => {
          this.renderChart(trend)
        }, 10)
      }
      this.setState({
        gender: gender, // 性别
        vnum: vnum, // 访问次数
        customerType: customerType, //新老用户
        loading: false,
        trend,
      })
    })
  }
  renderChart(vdata) {
    let datas = [
      {
        name: "老顾客对比指数",
        data: vdata[0],
      },
      {
        name: "新顾客对比指数",
        data: vdata[1],
      },
    ]

    let xAxisNames = []
    for (let i = vdata[0].length; i--; i >= 0) {
      xAxisNames.push(
        moment()
          .subtract("days", i + 1)
          .format("MM-DD")
      )
    }
    // setPassTitle (data.report);
    var option = {
      backgroundColor: "#1F1C40",
      tooltip: {
        trigger: "axis",
      },
      legend: {
        right: "3%",
        top: 0,
        itemGap: 16,
        data: datas.map((d) => {
          return { name: d.name }
        }),
        textStyle: {
          color: "#a8aab0",
          fontStyle: "normal",
          fontFamily: "微软雅黑",
          fontSize: 10,
        },
      },
      color: ["#6299f5", "#ffcd62", "#F03599"],
      grid: {
        top: 50,
        bottom: 50,
        // left: "50",
        // right: "50",
      },
      xAxis: {
        // type: "category",
        boundaryGap: true,
        axisLabel: {
          formatter: "{value}",
          color: "#8c939b",
          rotate: -45,
        },
        data: xAxisNames,
        axisLine: {
          show: true,
        },
        axisTick: {
          show: true,
          inside: true,
        },
      },
      yAxis: {
        type: "value",
        axisLabel: {
          formatter: "{value}",
          color: "#8c939b",
        },
        axisLine: {
          show: true,
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          lineStyle: {
            color: ["#333"],
          },
        },
      },
      series: datas.map((d) => {
        return {
          name: d.name,
          type: "bar",
          data: d.data,
          symbolSize: 8,
        }
      }),
    }
    var chart = (this.chart = echarts.init(
      document.getElementById("customerTrend")
    ))
    chart.setOption(option)
    Util.registerChartsResize(chart)
  }
  render() {
    let { loading, gender, vnum, customerType, trend } = this.state
    const content = (
      <div>
        新顾客占比=新顾客数/总顾客数
        <br />
        老顾客占比=老顾客数/总顾客数
      </div>
    )
    return (
      <div className="box-visitor-count">
        <Loading loading={loading} />
        {vnum ? (
          <div>
            <h2 className="visit-h2 shop-body-title">
              <i className="icon" />
              <span className="i-title">来访次数</span>
            </h2>
            <div id="customerPie" className="bottom-line">
              <Pie conf={{ title: "", list: vnum, unit: "人" }} />
            </div>
          </div>
        ) : null}
        {customerType ? (
          <div>
            <h2 className="visit-h2 shop-body-title">
              <i className="icon" />
              <span className="i-title">
                <span>新老顾客</span>
                <Popover content={content} placement="right">
                  <Icon type="question-circle" theme="filled" />
                </Popover>
              </span>
            </h2>
            <div id="customerTypePie" className="bottom-line">
              <Pie conf={{ title: "", list: customerType, unit: "%" }} />
            </div>
          </div>
        ) : null}
        {trend ? (
          <div>
            <div
              id="customerTrend"
              className="bottom-line"
              style={{ height: 400 }}
            >
              {/* <Pie conf={{ title: "", list: customerType, unit: "%" }} /> */}
            </div>
          </div>
        ) : null}
        {gender ? (
          <div>
            <h2 className="p-sex shop-body-title">
              <i className="icon" />
              <span className="i-title">性别分布</span>
            </h2>
            <div className="sexBox ">
              <Sex values={[gender.male, gender.female]} />
            </div>
          </div>
        ) : null}
      </div>
    )
  }
}

export default VisitorCount
